import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { hideNetlifyBadge } from '@avexa/config/hide-netlify-badge'

import { App } from './App'
import './i18n'
import './index.css'

// Netlify injects a "Powered by Netlify" badge on the free plan, after the
// document is served, so it cannot be removed at build time. The CSS in
// index.css hides it on first paint; this watches for it in case Netlify
// changes the markup, which they have done before.
hideNetlifyBadge()

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element in index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
